/* =====================================================================
   ENTROPICA CORE ENGINE (GLOBAL SCOPE)
   ===================================================================== */

document.addEventListener("DOMContentLoaded", function() {

  /* --- 1. MASTER CART DRAWER OVERRIDE (GLOBAL CAPTURE) --- */
  if (!window.entropicaMasterCartBound) {
    document.addEventListener('click', function(e) {
      const cartBubble = e.target.closest('#cart-icon-bubble, .header__icon--cart, a[href^="/cart"]');
      if (cartBubble) {
        // Prevent default navigation to the /cart page
        e.preventDefault(); 
        e.stopImmediatePropagation(); 
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open(cartBubble);
          } else {
            cartDrawer.classList.add('is-active', 'active', 'animate');
            document.body.classList.add('overflow-hidden');
          }
        }
      }
    }, true); // Use capture phase to intercept before native theme JS
    window.entropicaMasterCartBound = true;
  }

  /* --- 2. UNIVERSAL AJAX CART ENGINE --- */
  // This will bind to any form with the class 'entropica-ajax-form'
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.entropica-ajax-form');
    if (!form) return;

    e.preventDefault(); 
    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;
    
    const originalText = submitBtn.innerText;
    submitBtn.innerText = 'Processing...';
    submitBtn.disabled = true;

    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    const fetchUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';

    fetch(fetchUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, 
      body: formData
    })
    .then(res => { if (!res.ok) throw new Error('Network response error'); return res.json(); })
    .then(data => {
      // Logic for pre-order text swap
      const isPreorder = submitBtn.dataset.preorder === "true";
      submitBtn.innerText = isPreorder ? 'Pre-Order Secured' : 'Secured';
      
      // Inject updated Dawn sections
      if (data.sections) {
        if (data.sections['cart-drawer']) {
          const parsedDrawer = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          const currentDrawer = document.querySelector('cart-drawer');
          const newDrawer = parsedDrawer.querySelector('cart-drawer');
          if (currentDrawer && newDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            currentDrawer.className = newDrawer.className; 
          }
        }
        if (data.sections['cart-icon-bubble']) {
          const parsedBubble = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const currentBubble = document.querySelector('#cart-icon-bubble');
          const newBubble = parsedBubble.querySelector('#cart-icon-bubble');
          if (currentBubble && newBubble) currentBubble.innerHTML = newBubble.innerHTML;
        }
      }

      // Trigger the drawer
      const drawerElement = document.querySelector('cart-drawer');
      if (drawerElement) {
         if (typeof drawerElement.open === 'function') drawerElement.open(); 
         else { drawerElement.classList.add('active'); document.body.classList.add('overflow-hidden'); }
      } else {
         document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      }

      setTimeout(() => { submitBtn.innerText = originalText; submitBtn.disabled = false; }, 2000);
    })
    .catch(error => {
      console.error('Entropica Cart Error:', error);
      submitBtn.innerText = 'System Error.';
      setTimeout(() => { submitBtn.innerText = originalText; submitBtn.disabled = false; }, 3000);
    });
  });

  /* --- 3. SCROLL REVEAL ENGINE (fade-in-content / staggered-item / titanium-sweep) --- */
  if ('IntersectionObserver' in window) {
    const revealTargets = document.querySelectorAll('.fade-in-content, .staggered-item, .titanium-sweep');

    if (revealTargets.length) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      revealTargets.forEach((target) => revealObserver.observe(target));
    }
  } else {
    // Fallback: no IntersectionObserver support, reveal everything immediately
    document.querySelectorAll('.fade-in-content, .staggered-item, .titanium-sweep').forEach((target) => {
      target.classList.add('is-visible');
    });
  }

});